import React, {useState} from 'react'
import AlertDialog from '../../../../../components/AlertDialog/index.es6'
import { CircularProgress, Grid } from '@mui/material'
import ButtonInc from '../../../../../shared-ui/ButtonInc'
import { reloadPage } from '../../../../../lib/utils.es6'
import ModalInc from '../../../../../shared-ui/ModalInc'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { getUserFullname, getUserGuid } from '../../../../../lib/access.es6'

const RejectPolicy = (props) => {

  const [reasonForRejection, setReasonForCancellation] = useState('');

  const handleChange = (event) =>{
    const {name, value} = event.target

    if(name === "reasonForRejection"){
      setReasonForCancellation(value)
    }
  }

  if (!props.policy) {
    return ""
  }

  const web_agent_guid = getUserGuid();
  const web_agent_name = getUserFullname();

  const rejectPolicy = () =>{
    const payload = {
      "note": reasonForRejection,
      "policy_guid": props.policy_guid,
      "web_user": web_agent_name,
      "web_user_guid": web_agent_guid
    }
    props.handleAddPolicyNotes(payload);
    props.rejectPolicy();
    console.log("note payload",payload )
  }
  const handlePolicyApprovedSuccessfully = () => {
    reloadPage()
  }

  const handlePolicyApprovalError = () => {
    reloadPage()

  }

  return (
    <>

      <AlertDialog
        custom
        show={props.showRejectPolicyProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2>Rejecting policy number {props.policyNumber}...</h2>
      </AlertDialog>


      <AlertDialog
        success
        show={props.showRejectPolicySuccessAlert}
        size="sm"
        title={`Policy number ${props.policyNumber} has been rejected`}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => { handlePolicyApprovedSuccessfully() }}
        confirmBtnText={'Ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'Cancel'}
        confirmBtnCssClass
      >
        <div >
          <ButtonInc variant="contained" onClick={() => { handlePolicyApprovedSuccessfully() }} style={{ background: 'green', }}>Ok</ButtonInc>
        </div>
      </AlertDialog>

      <AlertDialog
        show={props.showRejectPolicyErrorAlert}
        danger
        title={`Error rejecting policy ${props.policyNumber}`}
        onConfirm={() => handlePolicyApprovalError()}
        confirmBtnText={'Try again'}
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >
        {props.rejectPolicyError ? props.rejectPolicyError.message : ''}
      </AlertDialog>


      <ModalInc
        modalTitle="Add reasons for rejecting the policy"
        subTitle="Fill the below field to give reasons for rejecting the policy"
        open={props.openRejectPolicyDialog}
        onClose={props.toggleOpenRejectPolicyDialog}
        fullWidth
      >
        <ValidatorForm onSubmit={() => rejectPolicy()} >

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <TextValidator
                name='reasonForRejection'
                id="reasonForRejection"
                label="Enter reason for rejecting the policy "
                value={reasonForRejection}
                onChange={handleChange}
                multiline
                rows={5}
                maxRows={4}
                fullWidth
                variant="outlined"
                validators={['required']}
                errorMessages={['Please enter reason for rejecting the policy']}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} >
            <Grid item xs={12} sm={6} md={6}>

            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={8} md={8}>
                  <ButtonInc
                    variant="contained"
                    color="primary"
                    size="large"
                    type='submit'
                    style={{ marginTop: "20px", float: "right" }}
                  >
                    Reject Policy
                  </ButtonInc>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <ButtonInc
                    variant="contained"
                    color="primary"
                    size="large"
                    style={{ marginTop: "20px" }}
                    onClick={props.toggleOpenRejectPolicyDialog}
                  >
                    Go back
                  </ButtonInc>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

        </ValidatorForm>

      </ModalInc>
    </>
  )
}

export default RejectPolicy